import { render, staticRenderFns } from "./orgindex.vue?vue&type=template&id=244acca7&scoped=true&"
import script from "./orgindex.vue?vue&type=script&lang=js&"
export * from "./orgindex.vue?vue&type=script&lang=js&"
import style0 from "./orgindex.vue?vue&type=style&index=0&id=244acca7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244acca7",
  null
  
)

export default component.exports